import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {UserDataService} from '../user-data.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class JobLoginComponent implements OnInit {

    // Server Response After Send
    serverResp = false;
    formHasBeenSend = false;
    formSuccessfulSend = false;
    emailNotActive: boolean;
    userBlacklisted: boolean;
    blackListReason: string;

    loggedIn: string;

    constructor(private loginService: UserDataService,
                private router: Router,
                private route: ActivatedRoute) {
    }


    formResponse: boolean;
    formSent: boolean;

    ngOnInit() {

        this.loggedIn = localStorage.getItem("loggedIn");
        
        if(this.loggedIn === 'true'){

        this.loginService.getMainData()
            .subscribe(user => {
                if (user) {
                    this.router.navigate(['/cont']);
                }
            });
        }
    }

    onSubmit(form: NgForm) {
        this.formSent = false;
        // Form Value
        const email = form.value.email;
        const password = form.value.password;
        this.loginService.login(email, password).subscribe(resData => {
            this.formSent = false;
            this.loginService.isLoggedIn = true;
            localStorage.setItem("loggedIn",JSON.stringify(true));
            this.router.navigate(['/cont']);
        }, error => {
            this.formResponse = false;
            this.formSent = true;
            this.emailNotActive = error.error.reason === 'userNotActive';
            this.userBlacklisted = error.error.reason.includes('Blacklist')
            this.blackListReason = error.error.reason.split(':')[1];
        });
    }
}
